import Observer from "../observer";
import { RouteView } from "./view"
import { RouteModel } from "./model";

export class RouteComponent extends Observer{
    constructor(){
        super();
    }

    init(){
        this.routeModel = new RouteModel();
        this.routeView = new RouteView();
        this._attachSubscriptions();
        this.routeModel.init();
        this.routeView.init({
            rootElement: document.querySelector('.js-route-component'),
            ...this.routeModel.getRouteSettings()
        })
    }
    repaintRoute(){
        const routeSettings = this.routeModel.getRouteSettings();
        this.publish('route:delete', routeSettings.routeId);
        this.publish('routeAdd:data:processing:finish', {...routeSettings, ...{ enableFitToTheBounds: false }});
    }
    _attachSubscriptions() {

        this.routeView.subscribe('route:color:update', (payload)=> {
            this.routeModel.setRouteColor(payload);
            this.publish('route:color:update', this.routeModel.getRouteSettings());
        }, this);

        this.routeView.subscribe('route:width:update', (payload)=> {
            this.routeModel.setRouteWidth(payload);
            this.publish('route:width:update', this.routeModel.getRouteSettings());
        }, this);

        this.routeView.subscribe('route:delete', () => {
            this.routeModel.cleanStorage();
            const { routeId } = this.routeModel.getRouteSettings();
            this.publish('route:delete', routeId);
        }, this);

        this.routeView.subscribe('route:select:add', (payload) => {
            this.publish('routeAdd:data:processing:start');
            this.routeModel.onSelectRoute(payload)
        }, this);

        this.routeView.subscribe('route:file:add', (payload) => {
            this.publish('routeAdd:data:processing:start');
            this.routeModel.addCustomRouteFile(payload);
        }, this);

        this.routeView.subscribe('route:textarea:add', (payload) => {
            this.publish('routeAdd:data:processing:start');
            this.routeModel.addCustomRoute(payload)
        }, this);

        this.routeModel.subscribe('errorEmit', () => {
            this.routeView.onErrorEmit();
            this.publish('routeAdd:data:processing:error');
        }, this);

        this.routeModel.subscribe('validGeoJSONFile', this.routeView.hideErrorMessage, this.routeView);

        this.routeModel.subscribe('route:data:ready', () => {
            this.publish('routeAdd:data:processing:finish', this.routeModel.getRouteSettings());
        }, this);
    }
}
